import React, { useState } from 'react';
import { Switch } from '@/components/ui/switch';
import { Slider } from '@/components/ui/slider';
import { Button } from '@/components/ui/button';
import { Volume2, VolumeX } from 'lucide-react';

const KEY = 'shabz_scan_beep';
const read = () => {
  try { const raw = localStorage.getItem(KEY); if (raw) return { enabled: true, volume: 1, ...JSON.parse(raw) }; } catch (e) { /* default */ }
  return { enabled: true, volume: 1 };
};

// Plays the same accepted-scan chirp so the user can preview the current volume.
const testBeep = (vol) => {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC || vol <= 0) return;
    const ctx = new AC(); const t0 = ctx.currentTime;
    const tone = (freq, start, dur) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = 'square'; o.frequency.value = freq; o.connect(g); g.connect(ctx.destination);
      g.gain.setValueAtTime(0.5 * vol, t0 + start);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + start + dur);
      o.start(t0 + start); o.stop(t0 + start + dur);
    };
    tone(1180, 0, 0.10); tone(1650, 0.10, 0.13);
    setTimeout(() => ctx.close(), 600);
  } catch (e) { /* audio unsupported */ }
};

export function ScanSoundPanel() {
  const [pref, setPref] = useState(read);
  const persist = (next) => { setPref(next); try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* ignore */ } };
  const setEnabled = (v) => persist({ ...pref, enabled: v });
  const setVolume = (arr) => { const v = (Array.isArray(arr) ? arr[0] : arr) / 100; persist({ ...pref, volume: v }); };

  return (
    <div className="rounded-2xl border border-border bg-card p-4" data-testid="scan-sound-panel">
      <div className="mb-1 flex items-center gap-2">
        {pref.enabled ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
        <p className="text-sm font-semibold">Scan sounds</p>
      </div>
      <p className="mb-3 text-xs text-muted-foreground">Beep &amp; vibrate feedback for Scan &amp; Move (and other scanning). Turn off to keep it silent.</p>

      <div className="flex items-center justify-between rounded-xl bg-secondary/40 px-3 py-2.5">
        <span className="text-sm font-medium">Beep on scan</span>
        <Switch checked={pref.enabled} onCheckedChange={setEnabled} data-testid="scan-sound-enabled" />
      </div>

      <div className={`mt-3 ${pref.enabled ? '' : 'pointer-events-none opacity-50'}`}>
        <div className="mb-1 flex items-center justify-between">
          <span className="text-xs text-muted-foreground">Volume</span>
          <span className="text-xs font-medium">{Math.round((pref.volume ?? 1) * 100)}%</span>
        </div>
        <Slider value={[Math.round((pref.volume ?? 1) * 100)]} min={0} max={100} step={5} onValueChange={setVolume} data-testid="scan-sound-volume" />
        <Button variant="outline" size="sm" className="mt-3 h-9 rounded-lg" onClick={() => testBeep(pref.enabled ? (pref.volume ?? 1) : 0)} data-testid="scan-sound-test">Test beep</Button>
      </div>
    </div>
  );
}
